import { Button } from "@/components/wrappers/Aria/AriaWrapper.tsx"
import { ReactNode } from "react"

export function SideBarExpandButton({
  onPress,
  children,
}: {
  onPress: () => void
  children: ReactNode
}) {
  return (
    <Button
      className={"h-full w-full dark:hover:bg-cyan-700"}
      onPress={onPress} aria-label="Expand"
    >
      {children}
    </Button>
  )
}
